module.exports = __webpack_public_path__ + "img/fauteuil-27.584cac31.jpg";